<template>
    <div class="news-events-page">
        <fancy-header></fancy-header>
        <div class="container">
            <div class="loading getmore-div" v-show="isLoading">
                <div class="fas fa-spinner fa-spin" >
                </div>
            </div>
            <div class="row" v-show="!isLoading">
                <div class="col-xs-12">
                    <div class="col-xs-12 bordered" v-show="false">
                        <ul class="nav nav-pills">
                            <li role="presentation" class="active"><a href="#">الكل</a></li>
                            <li role="presentation" class=""><a href="#">الأخبار</a></li>
                            <li role="presentation" class=""><a href="#">الفعاليات و الانشطة</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-6 col-xs-12 news-item-container min-height" v-for="newsItem in news" :key="newsItem.Id">
                        <New :news="newsItem"></New>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import New from '@/components/news and events/new'
    import FancyHeader from '@/components/shared/fancy-header'

    export default {
        name: 'NewsAndEvents',

        data: () => ({
            news: [
                // {
                //     Id:'1',
                //     Title:'News Title',
                //     Image:{
                //         Url:'src/assets/img/aleppo-night.jpg'
                //     },
                //     Subdescription:'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Est fugiat repellat alias, autem recusandae voluptatibus obcaecati, veniam corporis delectus odit magni quia. Ullam quis corporis, ratione delectus consectetur cumque nam.'
                // },
               
            ],
            isLoading: false,
        }),

        mounted() {
            this.isLoading = true;
            axios.get(apiHost + "/news")
                .then((response) => {
                    this.news = response.data;
                })
                .finally(() => this.isLoading = false);

          var footerheight =  $('.footer').height();
          var headerheight = $('.navbar-inverse').height();
          var height = $(window).height() - (footerheight + headerheight);
           $('.min-height').css({"min-height":height});
        },

        components: {
            New,
            FancyHeader
        }
    }
</script>
<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .news-events-page {
                .container {
                    margin-top: 30px;
                    margin-bottom: 30px;
                    direction:$dir;

                    .news-item-container{
                        @include float-left($dir);
                    }
                }
                .bordered {
                    border-bottom: 1px solid #ccc;
                    margin-bottom: 15px;
                    padding: 10px 0px;
                }
                .nav-pills {
                    @include float-left($dir);

                    & > li {
                        @include float-left($dir);
                        &.active {
                            a {
                                background-color: $main-color;
                                color: #fff;
                            }
                        }
                        a {
                            &:hover, &:focus {
                                color: $main-color;
                            }
                        }
                    }
                }
                .loading.getmore-div{
                    text-align:center;
                    margin-top:15px;
                    height: 200px;
                    .fa-spin{
                        font-size:20px;
                        color:$main-color;
                    }
                }
            }


</style>



// WEBPACK FOOTER //
// src/components/news and events/index.vue